import type { ReactElement } from "react";
import styled, { keyframes } from "styled-components";

const placeholderShimmer = keyframes`
    0% {
        background-position: -468px 0;
    }
    
    100% {
        background-position: 468px 0;
    }
`;

const Container = styled.div<{ height?: string; width?: string }>`
    animation-duration: 1s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-name: ${placeholderShimmer};
    animation-timing-function: linear;
    background: #f6f7f8;

    background-image: linear-gradient(
        to right,
        #f6f7f8 0%,
        #edeef1 20%,
        #f6f7f8 40%,
        #f6f7f8 100%
    );
    background-repeat: no-repeat;
    background-size: ${({ width, height }) =>
        `${width ?? "800px"} ${height ?? "104px"}`};
    border-radius: 4px;
    height: ${({ height }) => height ?? "16px"};
    margin: 2px;
    position: relative;
    width: ${({ width }) => width ?? "100%"};
    align-items: center;
    justify-content: center;
    display: flex;
`;

interface Props {
    height?: string;
    width?: string;
    loadingText?: string;
}

const SkeletonLoader = ({
    height,
    width,
    loadingText,
}: Props): ReactElement => (
    <Container data-testid="skeleton" id="skeleton" {...{ height, width }}>
        {loadingText}
    </Container>
);

export default SkeletonLoader;
